// sales types
export const REPORT_SALE_ERROR = 'REPORT_SALE_ERROR';
export const REPORT_SALE_LOADING = 'REPORT_SALE_LOADING';
export const REPORT_SALE_SUCCESS = 'REPORT_SALE_SUCCESS';
export const REPORT_SALE_RESET = 'REPORT_SALE_RESET';

// debts types
export const REPORT_DEBTS_ERROR = 'REPORT_DEBTS_ERROR';
export const REPORT_DEBTS_LOADING = 'REPORT_DEBTS_LOADING';
export const REPORT_DEBTS_SUCCESS = 'REPORT_DEBTS_SUCCESS';
export const REPORT_DEBTS_RESET = 'REPORT_DEBTS_RESET';

// invoice types
export const REPORT_INVOICE_ERROR = 'REPORT_INVOICE_ERROR';
export const REPORT_INVOICE_LOADING = 'REPORT_INVOICE_LOADING';
export const REPORT_INVOICE_SUCCESS = 'REPORT_INVOICE_SUCCESS';
export const REPORT_INVOICE_RESET = 'REPORT_INVOICE_RESET';




// WEBPACK FOOTER //
// ./src/store/modules/report/mutation-types.js